module.exports = __webpack_public_path__ + "media/images/top/seminars/template/image08-2a6188ca251fc33aca50b4bd092fcd74.jpeg";